<header mat-dialog-title class="header-title">
  <div class="header-title-content">
    <span *ngIf="user">Modifica Utente: {{ user.name }} {{ user.surname }}</span>
    <span *ngIf="!user" class="new-item">Nuovo Utente</span>
  </div>
  
  <div class="header-actions" *ngIf="user">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteUser()">
        <mat-icon>delete</mat-icon>
        Elimina Utente
      </button>
    </mat-menu>
  </div>
</header>

<mat-dialog-content>
  <form [formGroup]="usersForm" novalidate>

    <!-- Nome e Cognome -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label class="label">Nome</mat-label>
        <input matInput formControlName="name" placeholder="Nome" />
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Cognome</mat-label>
        <input matInput formControlName="surname" placeholder="Cognome" />
      </mat-form-field>
    </div>

    <!-- Email e Telefono -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Email" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Telefono</mat-label>
        <input matInput formControlName="phone" type="tel" placeholder="Telefono" />
      </mat-form-field>
    </div>

    <!-- Ruolo e Stato -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Ruolo</mat-label>
        <mat-select formControlName="role">
          <mat-option value="admin">Admin</mat-option>
          <mat-option value="manager">Manager</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <mat-form-field class="u-full-width">
        <mat-label>Stato</mat-label>
        <mat-select formControlName="active">
          <mat-option [value]="1">Attivo</mat-option>
          <mat-option [value]="0">Disattivato</mat-option>
        </mat-select>
      </mat-form-field> -->
      <mat-slide-toggle class="u-full-width" formControlName="active" color="primary">
        Attivo
    </mat-slide-toggle>
    </div>

    <!-- Punto Vendita per Manager -->
    <div class="u-flex-full">

      <mat-form-field class="u-full-width" *ngIf="!user?.id">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" type="password" placeholder="Password"/>
      </mat-form-field>


      <mat-form-field class="u-full-width" *ngIf="usersForm.value.role === 'manager'">
        <input type="text" matInput placeholder="Cerca Punto Vendita"
               [formControl]="tenantSearchControl"
               [matAutocomplete]="tenantsAutocomplete">

        <mat-autocomplete #tenantsAutocomplete="matAutocomplete" (optionSelected)="selectTenant($event)">
          <mat-option *ngFor="let tenant of filteredTenants | async" [value]="tenant">
            {{ tenant.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

    </div>


    <div class="u-flex-full">
            <!-- Mostra i tenant selezionati come chips -->
            <mat-chip-list *ngIf="selectedTenants.length">
              <mat-chip *ngFor="let tenant of selectedTenants" (removed)="removeTenant(tenant)">
                {{ tenant.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>

    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="left-actions">
    <span>
      <button mat-raised-button (click)="revert()" [disabled]="usersForm.pristine">
        Reset
      </button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="usersForm.pristine || !usersForm.valid">
        Salva
      </button>
    </span>
  </div>
  <div class="right-actions">
    <button mat-raised-button (click)="close()">
    Chiudi
  </button>
  </div>
</mat-dialog-actions>
